module.exports = __webpack_public_path__ + "img/finagent-chat-icon-dark.456667b.svg";